import React from "react"
import BackButton from "./BackButton"
import NextButton from "./NextButton"

type optionsType = {
    label: string
    value: string
}

type SelectionFieldType = {
    onNext: () => void
    onBack?: () => void
    option: optionsType[]
    label: string
    onSelect: (value: string) => void
    selectedValue?: string
    submit: boolean
    onSubmit: () => void
}

export default function SelectionField(props: SelectionFieldType) {
    const isSelected = (props.selectedValue ?? "").trim() !== "";
    return (
        <div className="py-8 w-full flex flex-col items-end">
            <div className=" text-xl sm:text-2xl pb-4 w-full">{props?.label}</div>
            <div className="flex flex-col space-y-4 pl-4 w-full">
                {props.option.map((option, index) => (
                    <label key={index} className="flex items-center space-x-2 text-xl sm:text-2xl cursor-pointer">
                        <input
                            type="radio"
                            name="selection"
                            value={option.value}
                            checked={props.selectedValue === option.value}
                            onChange={() => props.onSelect(option.value)}
                            className="form-radio accent-primary"
                        />
                        <span>{option.label}</span>
                    </label>
                ))}
            </div>
            <div className="flex gap-4 w-full sm:w-fit pt-16 sm:pt-0">
                {props.onBack && (
                    <BackButton onBack={props.onBack} />
                )}
                <NextButton
                    filled={isSelected}
                    submit={props.submit}
                    onNext={props.onNext}
                    onSubmit={props.onSubmit}
                />
            </div>
        </div>
    )
}

